module.exports = __webpack_public_path__ + "static/media/godOfMars-4.5de78080.png";